// Label the optional feedback fields injected by the translation plugin.
export default function labelTranslationFeedback() {
  let nextId = 0;
  const labelFields = () => {
    document.querySelectorAll("textarea").forEach((field) => {
      const placeholder = field.getAttribute("placeholder") || "";
      const isIssue = /^describe your issues/i.test(placeholder);
      const isSuggestion = /^suggested feedback$/i.test(placeholder.trim());
      if (!isIssue && !isSuggestion && !field.closest(".bhashini-feedback-form")) return;

      const text = isSuggestion || /suggested/i.test(field.id)
        ? "Suggested feedback"
        : "Describe your issues";
      if (!field.labels?.length) {
        if (!field.id) {
          let id;
          do {
            id = `translation-feedback-field-${++nextId}`;
          } while (document.getElementById(id));
          field.id = id;
        }
        const label = document.createElement("label");
        label.htmlFor = field.id;
        label.className = "sr-only";
        label.textContent = text;
        field.before(label);
      }
      if (!field.getAttribute("aria-label")?.trim()) {
        field.setAttribute("aria-label", text);
      }
    });
  };

  labelFields();
  const observer = new MutationObserver(labelFields);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["placeholder", "id", "aria-label", "for"],
  });
  return () => observer.disconnect();
}
